import React from 'react';
import SelectOrganizador from '../../selectores/SelectOrganizador';

const CampoComboOrganizador = (props) => {
  const nombre = props.nombre;
  const valor = props.valor;
  const editar = props.editar;
  const incluirNulo = props.incluirNulo;
  const estilo = props.estilo;

  const onOrganizadorElegido = (organizadorElegido) => {
    props.onChange(nombre, organizadorElegido);
  };

  // Función para obtener el valor mostrado de un organizador
  const getValorMostrado = (organizador) => {
    if (!organizador) return '';
    // Prioridad: nombreSimple si no es nulo, sino sigla
    return organizador.nombreSimple || organizador.sigla || '';
  };

  let campo = '';
  if (editar) {
    campo = (
      <SelectOrganizador
        organizadorActual={valor}
        incluirNulo={incluirNulo}
        estilo={estilo}
        onOrganizadorElegido={onOrganizadorElegido}
      />
    );
  } else {
    campo = getValorMostrado(valor);
  }

  return <React.Fragment>{campo}</React.Fragment>;
};

export default CampoComboOrganizador;
